import './header.scss';

function Header() {
  return (
    <header className="header">
      <div className="header__wrapper container">
        <h1 className="header__title">URL shortener </h1>
      </div>
    </header>
  );
}

export default Header;
